// ChatBot.jsx
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useTheme } from "../../context/ThemeContext";
import { Link } from "react-router-dom";

const ChatBot = () => {
    const { theme } = useTheme();

    const [isChatOpen, setIsChatOpen] = useState(false);
    const [question, setQuestion] = useState("");
    const [messages, setMessages] = useState([
        {
            text: "Hello! I might just have the inside scoop you're looking for! 😉 What you wanna know about Pratham 👀",
            sender: "Puru",
        },
        {
            text: "Better we should take some room 😁 , click on full-screen icon so we can chat peacefully 😊 ",
            sender: "Puru",
        },
    ]);
    const [loading, setLoading] = useState(false); // Loading state added

    const chatContainerRef = useRef(null);

    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop =
                chatContainerRef.current.scrollHeight;
        }
    }, [messages]);

    const toggleChat = () => {
        setIsChatOpen(!isChatOpen);
    };

    async function generateAnswer() {
        if (!question.trim()) return;

        const newMessages = [...messages, { text: question, sender: "You" }];
        setMessages(newMessages);
        setQuestion("");
        setLoading(true); // Set loading to true when starting to fetch

        try {
            const response = await axios.post(
                "https://profile-one-backend.onrender.com/api/generate",
                {
                    message: question,
                }
            );

            setMessages([
                ...newMessages,
                {
                    text:
                        response.data.reply ||
                        "Sorry, I couldn't find any information in the documentation about that.",
                    sender: "Puru",
                },
            ]);
        } catch (error) {
            console.error(error);
            setMessages([
                ...newMessages,
                {
                    text: "Error occurred while fetching the answer.",
                    sender: "Puru",
                },
            ]);
        } finally {
            setLoading(false); // Set loading to false after the fetch is complete
        }
    }

    return (
        <div className="relative group inline-block rounded-lg">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="currentColor"
                className="mx-2 cursor-pointer transition-transform duration-200 transform hover:scale-125"
                onClick={toggleChat}
            >
                {/* SVG Path */}
                <path d="M13.5 2C13.5 2.44425 13.3069 2.84339 13 3.11805V5H18C19.6569 5 21 6.34315 21 8V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V8C3 6.34315 4.34315 5 6 5H11V3.11805C10.6931 2.84339 10.5 2.44425 10.5 2C10.5 1.17157 11.1716 0.5 12 0.5C12.8284 0.5 13.5 1.17157 13.5 2ZM6 7C5.44772 7 5 7.44772 5 8V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V8C19 7.44772 18.5523 7 18 7H13H11H6ZM2 10H0V16H2V10ZM22 10H24V16H22V10ZM9 14.5C9.82843 14.5 10.5 13.8284 10.5 13C10.5 12.1716 9.82843 11.5 9 11.5C8.17157 11.5 7.5 12.1716 7.5 13C7.5 13.8284 8.17157 14.5 9 14.5ZM15 14.5C15.8284 14.5 16.5 13.8284 16.5 13C16.5 12.1716 15.8284 11.5 15 11.5C14.1716 11.5 13.5 12.1716 13.5 13C13.5 13.8284 14.1716 14.5 15 14.5Z"></path>
            </svg>

            {isChatOpen && (
                <div
                    className={`fixed rounded-lg bottom-20 right-10 lg:bottom-10 lg:right-10 w-min lg:w-max max-w-md lg:max-w-lg z-50 ${
                        theme === "dark" ? "bg-black" : "bg-white"
                    } `}
                >
                    <div className="flex flex-col h-full">
                        <div className="shadow-lg rounded-lg p-4 border border-gray-300">
                            <div className="flex flex-col space-y-1.5 pb-2">
                                <div className="flex justify-between">
                                    <div className="flex">
                                        <h2 className="font-semibold text-lg tracking-tight kanit-regular">
                                            Chat with Puru
                                        </h2>
                                    </div>
                                    <div className="flex">
                                        <Link to="/chatbot">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                width="24"
                                                height="24"
                                                fill="currentColor"
                                                className="mr-3 cursor-pointer transition-transform duration-200 transform hover:scale-110  "
                                                onClick={toggleChat}
                                            >
                                                <path d="M21 3H13.5L16.5429 6.04289L13.2929 9.29289L14.7071 10.7071L17.9571 7.45711L21 10.5V3ZM3 21H10.5L7.45711 17.9571L10.7071 14.7071L9.29289 13.2929L6.04289 16.5429L3 13.5V21Z"></path>
                                            </svg>
                                        </Link>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            width="26"
                                            height="26"
                                            fill="currentColor"
                                            className="mr-2 cursor-pointer transition-transform duration-300 transform hover:scale-125"
                                            onClick={toggleChat}
                                        >
                                            {/* SVG Path */}
                                            <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            {/* Scrollable Chat Area with responsive height */}
                            <div
                                ref={chatContainerRef}
                                className="overflow-y-auto pr-4 mb-2 h-72 lg:h-96"
                            >
                                {messages.map((message, index) => (
                                    <div
                                        key={index}
                                        className={`my-2 flex  ${
                                            message.sender === "Puru"
                                                ? "justify-start"
                                                : "justify-end"
                                        }`}
                                    >
                                        <div
                                            className={`p-2 rounded-lg ${
                                                message.sender === "Puru"
                                                    ? `${
                                                          theme === "dark"
                                                              ? "bg-gray-600 text-white"
                                                              : "bg-gray-200"
                                                      }`
                                                    : "bg-yellow-500 text-white"
                                            }`}
                                        >
                                            <strong className="block ">
                                                {message.sender}
                                            </strong>
                                            <p className=" ">{message.text}</p>
                                        </div>
                                    </div>
                                ))}

                                {/* Show loading indicator */}
                                {loading && (
                                    <div className="flex justify-center my-2">
                                        <span className="loading loading-dots loading-lg"></span>
                                    </div>
                                )}
                            </div>

                            <form
                                className="flex items-center"
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    generateAnswer();
                                }}
                            >
                                <input
                                    className={`flex-grow h-10 border  rounded-md px-3 text-sm  focus:outline-none focus:ring-2  focus:ring-yellow-500 ${
                                        theme === "dark"
                                            ? "bg-black text-white"
                                            : "bg-white text-black"
                                    } `}
                                    placeholder="Type your message"
                                    onChange={(e) =>
                                        setQuestion(e.target.value)
                                    }
                                    value={question}
                                />
                                <button
                                    type="submit"
                                    className="ml-2 h-10 px-4 bg-yellow-500  rounded-md hover:bg-yellow-600 text-white"
                                >
                                    Send
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChatBot;
